import React, { useState, useEffect, useRef } from 'react'
import ReactApexChart from 'react-apexcharts';
import Select from 'react-select';
import structuraldata from './structure';
import { Urls } from '../../../../Urls'
import axios from '../../../../Axios'
import Loader from '../../../Loader';
import classes from './irdashboard.module.css'
import { Activity, DateFormatter2, currentRequestTimeStamp, isMobile } from '../../../../Constants'
import Logo from '../../../../Content/images/logo3.png'
import ReactGA from 'react-ga4'
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import { useIndentTracking } from '../../hooks/useIndentTracking';

const Irdashboard = () => {
    const [durationstate, setdurationstate] = useState({ label: 'today', value: '1' })
    const [show, setshow] = useState(false)
    const [showdatepicker, setShowdatepicker] = useState(false)
    const [transporter_list, setTransporter_list] = useState([])
    const [acceptedCount, setAcceptedCount] = useState([])
    const [rejectedCount, setRejectedCount] = useState([])
    const [pendingCount, setPendingCount] = useState([])
    const [canceledcount, setCanceledcount] = useState([])
    const [data, setData] = useState([])
    const [customfiltered, setcustomfiltered] = useState(false)
    const [plantlist, setPlantlist] = useState([])
    const [selectedPlant, setSelectedPlant] = useState({ 'label': 'All', 'value': 'all' })
    const [customselectedplant, setcustomselectedplant] = useState({ 'label': 'All', 'value': 'all' })
    const [fromdate, setFromdate] = useState('')
    const [todate, setTodate] = useState('')
    const [clearfilter, setClearfilter] = useState(false)
    const [showSampleDashboard, setShowSampleDashboard] = useState(false)
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [selectedFilter, setSelectedFilter] = useState("Today");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
    var durationoptions = [
        // {label:'All', value: '0'},
        { label: 'Today', value: '1' },
        { label: 'Last 1 week', value: '2' },
        { label: 'Last 1 month', value: '3' },
        // {label:'Custom', value: '4'}
    ]
    const [selectenquirytype, setSelectedenquirytype] = useState('user_view')
    const [useroption, setUseroption] = useState([])
    const [selectusertype, setselectusertype] = useState("")
    const [selectedEnquiry, setSelectedEnquiry] = useState({ 'label': 'All', 'value': 'all' })

    var enquiryOptions = [
        { label: 'All', value: 'all' },
        { label: 'Spot', value: 'adhoc' },
        { label: 'Indent', value: 'indent' },
    ]

    const { trackIndentEvent } = useIndentTracking();

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };
    // const toggleDropdown = (e) => {
    //     setDropdownOpen(!dropdownOpen);
    // };
    const toggleDropdown = (e) => {
        if (!dropdownOpen && dropdownRef.current) {
            const rect = dropdownRef.current.getBoundingClientRect();
            setDropdownPos({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
        }
        setDropdownOpen(!dropdownOpen);
    };

    useEffect(() => {
        document.title = 'LoRRI Indent - Indent Request dashboard'
        ReactGA.send('LoRRI Indent - Indent Request dashboard')
        setshow(true)
        getData(`${Urls.indentdashboard}?field=indent_dashboard&window=${durationstate.value === "1" ? "today" : durationstate.value === "2" ? "week" : "month"}`, {
            "today": DateFormatter2(Date()),
            'plant': [selectedPlant.value],
            "view": selectenquirytype,
            "email": `${localStorage.getItem("useremail")}`,
            "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
            "from": selectedEnquiry.value
        })
        trackIndentEvent("indent request dashboard", "user has visited indent request dashboard")
    }, [])
    const handleSelect = (value) => {
        setSelectedFilter(value);
        setDropdownOpen(false);
    };

    const handleCustomDate = ({ date, type = "" }) => {
        setSelectedFilter("")
        if (type === "toDate") {
            setToDate(date.toISOString())
        } else if (type === "fromDate") {
            setFromDate(date.toISOString())
        }
    }

    const getData = (url, payload) => {
        setshow(true)
        axios.post(url, payload)
            .then((res) => {
                // console.log(res.data.result)
                if (res.data.result === false) {
                    var newdata = getFormatted(structuraldata)
                    setData(newdata)
                    setdetails(newdata)
                    setShowSampleDashboard(true)
                    setshow(false)
                } else {
                    newdata = getFormatted(res.data.data)
                    var pl = [{ 'label': 'All', 'value': 'all' }]
                    if (res.data && res.data.plant_list && res.data.plant_list.length > 0) {
                        res.data.plant_list.map((plant) => {
                            return pl.push({ 'label': plant, 'value': plant })
                        })
                    }
                    setPlantlist(pl)
                    setUseroption(res.data.user_list)
                    setData(newdata)
                    setdetails(newdata)
                    setShowSampleDashboard(false)
                    setshow(false)
                }
            }).catch((e) => {
                setshow(false)
                console.log(e)
            })
    }

    const getFormatted = (data) => {
        if (data && data.length > 0) {
            var formattedData = data.map((transporter) => {
                var pending = transporter.pending_indent
                var allocated = transporter.allocated_indent
                var accepted = transporter.accepted_indent
                var rejected = transporter.rejected_indent;

                return {
                    transporter_name: transporter.transporter_name,
                    transporter_id: transporter.transporter_id,
                    category: [
                        { indent_status: "pending", count: transporter.pending_indent },
                        { indent_status: "accepted", count: transporter.accepted_indent },
                        { indent_status: "rejected", count: transporter.rejected_indent },
                        { indent_status: "allocated", count: transporter.allocated_indent },
                    ],
                    total_category_value: pending + accepted + rejected + allocated,
                };
            });

            return formattedData;
        }

        return [];
    };

    const setdetails = (mydata) => {
        var tlist = [], alist = [], plist = [], rlist = [], clist = []
        if (mydata && mydata.length > 0) {
            mydata.map((transporter) => {
                if (transporter.transporter_id !== null && transporter.transporter_id !== "" && transporter.transporter_id !== undefined) {
                    tlist.push(transporter.transporter_name)
                    transporter.category.map((v) => {
                        if (v.indent_status === 'accepted') {
                            alist.push({ 'value': v.count })
                        }
                        if (v.indent_status === 'rejected') {
                            rlist.push({ 'value': v.count })
                        }
                        if (v.indent_status === 'pending') {
                            plist.push({ 'value': v.count })
                        }
                        if (v.indent_status === 'allocated') {
                            clist.push({ 'value': v.count })
                        }
                        return v
                    })
                }
                return transporter
            })
        }
        setTransporter_list(tlist)
        setAcceptedCount(alist)
        setRejectedCount(rlist)
        setPendingCount(plist)
        setCanceledcount(clist)
    }
    const getCustomDate = (date) => {
        var mindate = new Date(date)
        var day = ("0" + (mindate.getDate())).slice(-2)
        var month = ("0" + (mindate.getMonth() + 1)).slice(-2)
        var year = mindate.getFullYear()
        var td = year.toString() + '-' + month.toString() + "-" + day.toString() + ""
        return td
    }
    const getFinalWeek = (isCustom) => {
        var lastWeek = getLastWeek();
        var lastWeekMonth = ("0" + (lastWeek.getMonth() + 1)).slice(-2)
        var lastWeekDay = ("0" + (lastWeek.getDate())).slice(-2)
        var lastWeekYear = lastWeek.getFullYear();

        var fd = lastWeekYear.toString() + "-" + lastWeekMonth.toString() + "-" + lastWeekDay.toString();
        var mindate = new Date()
        var day = ("0" + (mindate.getDate())).slice(-2)
        var month = ("0" + (mindate.getMonth() + 1)).slice(-2)
        var year = mindate.getFullYear()
        var td = year.toString() + '-' + month.toString() + "-" + day.toString() + ""
        setFromdate(fd)
        setTodate(td)
        return { fd, td }
    }

    const getFinalMonth = (isCustom) => {
        if (isCustom && isCustom === true) {
            let maxdate = new Date(toDate)
            let mindate = new Date(fromDate)
            let minday = ("0" + (mindate.getDate())).slice(-2)
            // let minmonth = ("0" + (mindate.getMonth() + 1)).slice(-2)
            var minmonth = ("0" + (mindate.getMonth())).slice(-2)
            let minyear = mindate.getFullYear()
            let maxday = ("0" + (maxdate.getDate())).slice(-2)
            // let minmonth = ("0" + (mindate.getMonth() + 1)).slice(-2)
            var maxmonth = ("0" + (mindate.getMonth())).slice(-2)
            let maxyear = mindate.getFullYear()
            let fd = minyear.toString() + '-' + minmonth.toString() + "-" + minday.toString() + ""
            let td = maxyear.toString() + '-' + maxmonth.toString() + "-" + maxday.toString() + ""
            setFromdate(fd)
            setTodate(td)
            return { fd, td }
        } else {
            // let mindate = new Date()
            // let day = ("0" + (mindate.getDate())).slice(-2)
            // let month = ("0" + (mindate.getMonth() + 1)).slice(-2)
            // var month1 = ("0" + (mindate.getMonth())).slice(-2)
            // let year = mindate.getFullYear()
            // let fd = year.toString() + '-' + month1.toString() + "-" + day.toString() + ""
            // let td = year.toString() + '-' + month.toString() + "-" + day.toString() + ""
            // setFromdate(fd)
            // setTodate(td)
            const mindate = new Date();
            let day = ("0" + (mindate.getDate())).slice(-2);
            let month = ("0" + (mindate.getMonth() + 1)).slice(-2);
            var month1 = ("0" + (mindate.getMonth())).slice(-2);
            let year = mindate.getFullYear();

            const td = year.toString() + '-' + month.toString() + "-" + day.toString();
            if (mindate.getMonth() === 0) {  // If current month is January
                month1 = "12";  // December
                year -= 1;  // Previous year
            }
            const fd = year.toString() + '-' + month1.toString() + "-" + day.toString();
            return { fd, td }
        }
    }
    function getLastWeek() {
        var today = new Date();
        var lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
        return lastWeek;
    }
    const changeHandlerforduration = (e, filterValue) => {
        setSelectedFilter(filterValue);
        setcustomfiltered(false)
        setDropdownOpen(false);
        setClearfilter(true)
        Activity([{ "screen": "Indents", "module": "Indent Request Dashboard", "user_activity": `Fiters for (${e.label})`, "timestamp": currentRequestTimeStamp() }])

        trackIndentEvent("indent request dashboard", `user has clicked on select duration filter`, `Filtered by : ${e.label}, ${filterValue}`);

        if (e === '1') {
            setdurationstate({ label: 'today', value: '1' })
            setShowdatepicker(false)
            if (selectedPlant.value === 'all') {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=today`, {
                    "today": DateFormatter2(Date()),
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    'plant': [selectedPlant.value],
                    "from": selectedEnquiry.value
                })
            } else {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=today`, {
                    "today": DateFormatter2(Date()),
                    'plant': [selectedPlant.value],
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    "from": selectedEnquiry.value
                })
            }

        }
        else if (e === '2') {
            setdurationstate({ label: 'Last 1 week', value: '2' })
            setShowdatepicker(false)
            var fd = e === "2" ? getFinalWeek().fd : getFinalMonth().fd;
            var td = e === "2" ? getFinalWeek().td : getFinalMonth().td
            if (selectedPlant.value === 'all') {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=week`, {
                    "from_date": e === "2" || e === "3" ? fd : undefined,
                    "to_date": e === "2" || e === "3" ? td : undefined,
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    "from": selectedEnquiry.value,
                    'plant': [selectedPlant.value],
                })
            } else {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=week`, {
                    "from_date": e === "2" || e === "3" ? fd : undefined,
                    "to_date": e === "2" || e === "3" ? td : undefined,
                    'plant': [selectedPlant.value],
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    "from": selectedEnquiry.value
                })
            }
        }
        else if (e === '3') {
            setShowdatepicker(false)
            setdurationstate({ label: 'Last 1 month', value: '3' })
            setShowdatepicker(false)
            var fd = e === "2" ? getFinalWeek().fd : getFinalMonth().fd;
            var td = e === "2" ? getFinalWeek().td : getFinalMonth().td
            if (selectedPlant.value === 'all') {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=month`, {
                    "from_date": e === "2" || e === "3" ? fd : undefined,
                    "to_date": e === "2" || e === "3" ? td : undefined,
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    "from": selectedEnquiry.value,
                    'plant': [selectedPlant.value],
                })
            } else {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=month`, {
                    "from_date": e === "2" || e === "3" ? fd : undefined,
                    "to_date": e === "2" || e === "3" ? td : undefined,
                    'plant': [selectedPlant.value],
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    "from": selectedEnquiry.value
                })
            }
        }
    }

    const changeHandlerforplant = (e) => {
        Activity([{ "screen": "Indents", "module": "Indent  Request Dashboard", "user_activity": `Fiters for (${e.label})`, "timestamp": currentRequestTimeStamp() }])

        trackIndentEvent("indent request dashboard", `user has clicked on select plant filter`, `Filtered by : ${e.label}`);

        setSelectedPlant(e)
        setClearfilter(true)
        if (durationstate.value === '0') {
            if (e.value === 'all') {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=${durationstate.value === "1" ? "today" : durationstate.value === "2" ? "week" : "month"}`, {
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    'plant': [e.value],
                })
            } else {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=all&filter=plant`, {
                    'plant': [e.value],
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    "from": selectedEnquiry.value
                })
            }
        } else if (durationstate.value === '1') {
            if (e.value === 'all') {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=today`, {
                    "today": DateFormatter2(Date()),
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    "from": selectedEnquiry.value,
                    'plant': [e.value],
                })
            } else {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=today`, {
                    "today": DateFormatter2(Date()),
                    'plant': [e.value],
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    "from": selectedEnquiry.value
                })
            }

        } else if (durationstate.value === '2' || durationstate.value === '3') {
            var window = durationstate.value === '2' ? 'week' : 'month'
            var fd = durationstate.value === "2" ? getFinalWeek().fd : getFinalMonth().fd;
            var td = durationstate.value === "2" ? getFinalWeek().td : getFinalMonth().td
            if (e.value === 'all') {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=${window}`, {
                    "from_date": durationstate.value === "2" || durationstate.value === "3" ? fd : undefined,
                    "to_date": durationstate.value === "2" || durationstate.value === "3" ? td : undefined,
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    'plant': [e.value],
                    "from": selectedEnquiry.value
                })
            } else {
                getData(`${Urls.indentdashboard}?field=indent_dashboard&window=${window}`, {
                    "from_date": durationstate.value === "2" || durationstate.value === "3" ? fd : undefined,
                    "to_date": durationstate.value === "2" || durationstate.value === "3" ? td : undefined,
                    'plant': [e.value],
                    "view": selectenquirytype,
                    "email": `${localStorage.getItem("useremail")}`,
                    "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                    "from": selectedEnquiry.value
                })
            }
        }
    }

    const changeHandlerforEnquiry = (e) => {
        Activity([{ "screen": "Indents", "module": "Indent  Request Dashboard", "user_activity": `Fiters for (${e.label})`, "timestamp": currentRequestTimeStamp() }])

        trackIndentEvent("indent request dashboard", `user has clicked on select enquiry type filter`, `Filtered by : ${e.label}`);

        setSelectedEnquiry(e)
        setClearfilter(true)
        var fd = durationstate.value === "2" ? getFinalWeek().fd : getFinalMonth().fd;
        var td = durationstate.value === "2" ? getFinalWeek().td : getFinalMonth().td
        if (e.value === 'adhoc') {
            getData(`${Urls.indentdashboard}?field=indent_dashboard&window=${durationstate.value === "1" ? "today" : durationstate.value === "2" ? "week" : "month"}`, {
                from: "adhoc",
                "email": `${localStorage.getItem("useremail")}`,
                "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                "today": durationstate.value === "1" ? DateFormatter2(Date()) : undefined,
                'plant': [selectedPlant.value],
                "view": selectenquirytype,
                "from_date": durationstate.value === "2" || durationstate.value === "3" ? fd : undefined,
                "to_date": durationstate.value === "2" || durationstate.value === "3" ? td : undefined,
            })
        } else if (e.value === 'indent') {
            getData(`${Urls.indentdashboard}?field=indent_dashboard&window=${durationstate.value === "1" ? "today" : durationstate.value === "2" ? "week" : "month"}`, {
                from: "indent",
                "email": `${localStorage.getItem("useremail")}`,
                "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                'plant': [selectedPlant.value],
                "view": selectenquirytype,
                "today": durationstate.value === "1" ? DateFormatter2(Date()) : undefined,
                "from_date": durationstate.value === "2" || durationstate.value === "3" ? fd : undefined,
                "to_date": durationstate.value === "2" || durationstate.value === "3" ? td : undefined,
            })
        }
        else {
            getData(`${Urls.indentdashboard}?field=indent_dashboard&window=${durationstate.value === "1" ? "today" : durationstate.value === "2" ? "week" : "month"}`, {
                from: "all",
                "email": `${localStorage.getItem("useremail")}`,
                "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                'plant': [selectedPlant.value],
                "view": selectenquirytype,
                "today": durationstate.value === "1" ? DateFormatter2(Date()) : undefined,
                "from_date": durationstate.value === "2" || durationstate.value === "3" ? fd : undefined,
                "to_date": durationstate.value === "2" || durationstate.value === "3" ? td : undefined,
            })
        }
    }

    var series = [{
        name: 'Accepted',
        color: '#54af3a',
        data: acceptedCount.map((a) => a.value)
    }, {
        name: 'Rejected',
        color: 'rgb(214, 39, 40)',
        data: rejectedCount.map((a) => a.value)
    }, {
        name: 'Allocated',
        color: '#393185',
        data: canceledcount.map((a) => a.value)
    }, {
        name: 'Pending',
        color: '#727271',
        data: pendingCount.map((a) => a.value)
    },
    ]
    var options = {
        chart: {
            stacked: true,
            stackType: '100%'
        },
        plotOptions: {
            bar: {
                horizontal: true
            }
        },
        xaxis: {
            categories: transporter_list,
        },
        yaxis: {
        },
        stroke: {
            width: 1
        },
        toolbar: { show: 'false' },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + ""
                }
            }
        },
        dataLabels: {
            formatter: function (val, opt) {
                return val !== 0 ? Math.round(val) + '%' : ''
            }
        },
        legend: {
            position: 'right',
        }
    }

    const changeHandler = (e, t) => {
        // var sd = Date(e.target.value)
        // console.log(sd.toISOString())
        if (t === 'fd') {
            setFromdate(e.target.value)
        }
        if (t === 'td') {
            setTodate(e.target.value)
        }
        if (t === 'pl') {
            setcustomselectedplant(e)
        }
    }
    const submitHandler = () => {
        // Ensure to convert fromDate and toDate back to Date objects
        const parsedFromDate = fromDate ? new Date(fromDate) : null;
        const parsedToDate = toDate ? new Date(toDate) : null;

        // Check if both dates are set
        if (parsedFromDate && parsedToDate) {
            const diffInMonths = (parsedToDate.getFullYear() - parsedFromDate.getFullYear()) * 12 + (parsedToDate.getMonth() - parsedFromDate.getMonth());

            // Show error if the difference is greater than 3 months
            if (diffInMonths > 3) {
                toast.error('The date range cannot exceed 3 months.');
                return; // Prevent further execution
            }
        } else {
            toast.error('Please select both from and to dates.');
            return; // Prevent further execution
        }

        // Existing code...
        Activity([{ "screen": "Indents", "module": "Indent Request Dashboard", "user_activity": `Custom Filter Submit Button Clicked`, "timestamp": currentRequestTimeStamp() }]);
        trackIndentEvent("indent request dashboard", `user has clicked on custom date filter submit button`, `Filtered by : From Date - ${fromDate}, To Date - ${toDate}`);

        setShowdatepicker(false);
        setcustomfiltered(true);
        var fd = getCustomDate(fromDate);
        var td = getCustomDate(toDate);
        if (customselectedplant.value === 'all') {
            getData(`${Urls.indentdashboard}?field=indent_dashboard&window=custom`, {
                "from_date": fd,
                "to_date": td,
                "view": selectenquirytype,
                "email": `${localStorage.getItem("useremail")}`,
                "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
                'plant': [selectedPlant.value],
            });
        } else {
            getData(`${Urls.indentdashboard}?field=indent_dashboard&window=custom`, {
                "from_date": fd,
                "to_date": td,
                'plant': [selectedPlant.value],
                "view": selectenquirytype,
                "email": `${localStorage.getItem("useremail")}`,
                "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
            });
        }
    };


    var newdate = new Date()
    var day = ("0" + (newdate.getDate())).slice(-2)
    var month = ("0" + (newdate.getMonth() + 1)).slice(-2)
    var year = newdate.getFullYear()
    var maxdate = year.toString() + "-" + month.toString() + "-" + day.toString()

    const handleChangeIndenttype = (e) => {
        // console.log(e.target.value)
        Activity([{ "screen": "Indent Request Dashboard", "module": "Indent Dashboard", "user_activity": `View Dashboard for ${e.target.value}`, "timestamp": currentRequestTimeStamp() }])

        trackIndentEvent("indent request dashboard", `user has clicked on enquiry type (my/company indents) filter`, `Filtered by : ${e.target.value}`);

        setSelectedenquirytype(e.target.value)
        setselectusertype("")
        setshow(true)
        if (customfiltered === true) {
            var fd = getCustomDate(fromDate)
            var td = getCustomDate(toDate)
        } else {
            var fd = durationstate.value === "2" ? getFinalWeek().fd : getFinalMonth().fd;
            var td = durationstate.value === "2" ? getFinalWeek().td : getFinalMonth().td;
        }
        axios.post(`${Urls.indentdashboard}?field=indent_dashboard&window=${selectedFilter === "" ? "custom" : durationstate.value === "1" ? "today" : durationstate.value === "2" ? "week" : "month"}`, {
            "view": e.target.value,
            'plant': [selectedPlant.value],
            "email": `${localStorage.getItem("useremail")}`,
            "from_date": durationstate.value === "2" || durationstate.value === "3" || selectedFilter === "" ? fd : undefined,
            "to_date": durationstate.value === "2" || durationstate.value === "3" || selectedFilter === "" ? td : undefined,
            "email_list": selectenquirytype === "user_view" ? [selectusertype] : [""],
            "today": (durationstate.value === "1" && selectedFilter !== "") ? DateFormatter2(Date()) : undefined,
        })
            .then(res => {
                setshow(false)
                // console.log(res.data)
                setUseroption(res.data.user_list)
                if (res.data.result === false) {
                    var newdata = getFormatted(structuraldata)
                    setData(newdata)
                    setdetails(newdata)
                    setShowSampleDashboard(true)
                    setshow(false)
                } else {
                    newdata = getFormatted(res.data.data)
                    var pl = [{ 'label': 'All', 'value': 'all' }]
                    if (res.data && res.data.plant_list && res.data.plant_list.length > 0) {
                        res.data.plant_list.map((plant) => {
                            return pl.push({ 'label': plant, 'value': plant })
                        })
                    }
                    setPlantlist(pl)
                    setData(newdata)
                    setdetails(newdata)
                    setshow(false)
                }
            }).catch(e => {
                setshow(false)
                console.log(e)
            })
    }

    const handleChangeUsertype = (e) => {
        setselectusertype(e.target.value)
        Activity([{ "screen": "Indent Request Dashboard", "module": "Indent Dashboard", "user_activity": `View Dashboard for ${e.target.value}`, "timestamp": currentRequestTimeStamp() }])

        trackIndentEvent("indent request dashboard", `user has clicked on select user name filter for company indents`, `Filtered by : ${e.target.value}`);

        // setSelectedenquirytype('company_view')
        setshow(true)
        if (selectedFilter === "") {
            var fd = getCustomDate(fromDate)
            var td = getCustomDate(toDate)
        } else {
            var fd = durationstate.value === "2" ? getFinalWeek().fd : getFinalMonth().fd;
            var td = durationstate.value === "2" ? getFinalWeek().td : getFinalMonth().td;
        }
        axios.post(`${Urls.indentdashboard}?field=indent_dashboard&window=${selectedFilter === "" ? "custom" : durationstate.value === "1" ? "today" : durationstate.value === "2" ? "week" : "month"}`, {
            "email_list": [e.target.value],
            "view": selectenquirytype,
            'plant': [selectedPlant.value],
            "email": `${localStorage.getItem("useremail")}`,
            "today": (durationstate.value === "1" && selectedFilter !== "") ? DateFormatter2(Date()) : undefined,
            "from_date": durationstate.value === "2" || durationstate.value === "3" || selectedFilter === "" ? fd : undefined,
            "to_date": durationstate.value === "2" || durationstate.value === "3" || selectedFilter === "" ? td : undefined,
        })
            .then(res => {
                if (res.data.result === false) {
                    var newdata = getFormatted(structuraldata)
                    setData(newdata)
                    setdetails(newdata)
                    setShowSampleDashboard(true)
                    setshow(false)
                } else {
                    newdata = getFormatted(res.data.data)
                    var pl = [{ 'label': 'All', 'value': 'all' }]
                    setUseroption(res.data.user_list)
                    if (res.data && res.data.plant_list && res.data.plant_list.length > 0) {
                        res.data.plant_list.map((plant) => {
                            return pl.push({ 'label': plant, 'value': plant })
                        })
                    }
                    setPlantlist(pl)
                    setData(newdata)
                    setdetails(newdata)
                    setshow(false)
                }
            }).catch(e => {
                setshow(false)
                console.log(e)
            })
    }

    return (
        <div className="containers">
            <Loader show={show} />
            {showSampleDashboard ?
                <div>
                    <div>
                        <h4 style={{ color: 'grey', fontSize: '22px', marginLeft: '10%' }}><i>Currently there are no indent requests from your account</i></h4>
                        <center style={{ marginRight: '25%' }}><span>Sample indent request dashboard for your reference</span></center>
                    </div>
                </div>
                : null}
            <div
                className={isMobile() ? classes["mobileFilterRow"] : "row"}
                style={{
                    marginTop: isMobile() ? '2%' : '-85px',
                    width: "100%",
                    justifyContent: isMobile() ? "flex-start" : "end",
                    flexWrap: isMobile() ? "nowrap" : "wrap",
                    overflowX: isMobile() ? "auto" : "visible",
                    WebkitOverflowScrolling: "touch",
                }}
            >
                <div style={{ width: isMobile() ? "150px" : "13%", flexShrink: isMobile() ? 0 : undefined }} className='px-4'>
                    Select type
                    <Select
                        options={[
                            { label: "My Indents", value: "user_view" },
                            { label: "Company Indents", value: "company_view" },
                        ]}
                        value={{
                            label: selectenquirytype === "user_view" ? "My Indents" : "Company Indents",
                            value: selectenquirytype,
                        }}
                        onChange={(e) => handleChangeIndenttype({ target: { value: e.value } })}
                        className="Truck_type_select"
                        classNamePrefix="Truck_Prefix"
                        menuPortalTarget={document.body}
                        menuPlacement="bottom"
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        isSearchable={false}
                    />
                </div>
                {selectenquirytype === "company_view" ?
                    <div style={{ width: isMobile() ? "150px" : "10%", flexShrink: isMobile() ? 0 : undefined }} className='px-4'>
                        Select User
                        <div style={{ width: '100%' }}>
                            <Select
                                options={useroption && useroption.length > 0 ? useroption.map(item => ({ label: item, value: item })) : []}
                                value={selectusertype ? { label: selectusertype, value: selectusertype } : null}
                                placeholder="Select User"
                                onChange={(e) => handleChangeUsertype({ target: { value: e.value } })}
                                className="Truck_type_select"
                                classNamePrefix="Truck_Prefix"
                                menuPortalTarget={document.body}
                                menuPlacement="bottom"
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                isSearchable={false}
                            />
                        </div>
                    </div>
                    : null
                }
                <div style={{ width: isMobile() ? "150px" : "13%", flexShrink: isMobile() ? 0 : undefined }} className='px-4'>
                    Select Plant
                    <Select
                        isDisabled={customfiltered}
                        id={'default'}
                        options={plantlist}
                        value={selectedPlant}
                        onChange={changeHandlerforplant}
                        className="Truck_type_select"
                        classNamePrefix="Truck_Prefix"
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
                <div style={{ width: isMobile() ? "150px" : "13%", flexShrink: isMobile() ? 0 : undefined }} className='px-4'>
                    Enquiry Type
                    <Select
                        isDisabled={customfiltered}
                        id={'default'}
                        options={enquiryOptions}
                        value={selectedEnquiry}
                        onChange={changeHandlerforEnquiry}
                        className="Truck_type_select"
                        classNamePrefix="Truck_Prefix"
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
                {showdatepicker ? <div className={`${classes["modal-box"]}`}>
                    <div>
                        <div style={{ display: 'flex' }}>
                            <img src={Logo} alt="" className="logo_img" />
                            <h5 style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px', marginLeft: '36%' }}>Custom Filter</h5>
                        </div>
                        <button className="fa fa-close btn btn-sm btn-link" style={{ color: '#393186', float: 'right', marginTop: `${isMobile() ? '-10%' : '-6%'}` }} onClick={e => {
                            Activity([{ "screen": "Indents", "module": "Indent Request Dashboard", "user_activity": `Custom Filters Button Clicked`, "timestamp": currentRequestTimeStamp() }])
                            setShowdatepicker(false)
                        }}></button>
                    </div>
                    <hr />
                    <div className={`col-md-4`}>
                        From Date
                        <input type="date" style={{ height: '38px' }} value={fromdate} max={maxdate} onInput={e => changeHandler(e, 'fd')} />
                    </div>
                    <div className={`col-md-4`}>
                        To Date
                        <input type="date" style={{ height: '38px' }} value={todate} max={maxdate} onInput={e => changeHandler(e, 'td')} />
                    </div>
                    <div className={`col-md-4`}>
                        Plant/ Origin
                        <Select
                            options={plantlist}
                            value={customselectedplant}
                            id={'plant-location'}
                            onChange={e => changeHandler(e, 'pl')}
                            className="Truck_type_select"
                            classNamePrefix="Truck_Prefix"
                        /></div>
                    <center style={{ marginTop: '14%' }}><button className="btn btn-sm btn-primary" onClick={submitHandler}>Submit</button></center>
                </div> : null}
                <div className="dropdown" ref={dropdownRef} style={{ flexShrink: isMobile() ? 0 : undefined }}>
                    <button
                        className={`btn btn-secondary dropdown-toggle ${classes["dropDown-btn"]}`}
                        type="button"
                        id="dropdownMenuButton"
                        aria-haspopup="true"
                        aria-expanded="false"
                        onClick={(e) => toggleDropdown(e)}
                    >
                        {selectedFilter || "Filters"}
                    </button>
                    <div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`} aria-labelledby="dropdownMenuButton"
                        style={
                            isMobile() && dropdownOpen
                                ? {
                                    position: 'fixed',
                                    top: dropdownPos.top,
                                    left: dropdownPos.left,
                                    zIndex: 2000,
                                    maxHeight: '70vh',
                                    overflowY: 'auto',
                                }
                                : undefined
                        }>
                        {["Today", "Last 7 Days", "Last 30 Days"].map(
                            (filter, index) => (
                                <li
                                    style={{ userSelect: "none", cursor: 'pointer' }}
                                    key={filter}
                                    className={`dropdown-item ${selectedFilter === filter ? "active" : ""
                                        }`}
                                    onClick={() => changeHandlerforduration((index + 1).toString(), filter)}
                                >
                                    {filter}
                                </li>
                            )
                        )}
                        <div className="dropdown-divider"></div>
                        <div className={`dropdown-item drop${classes["custom-date-dropdown"]}`}>
                            <div className="mb-2">
                                Custom Date
                            </div>
                            <div className="">
                                <div className="">
                                    <div>From</div>
                                    <DatePicker
                                        maxDate={new Date(toDate)}
                                        selected={new Date(fromDate)}
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(date) => handleCustomDate({ date: date, type: "fromDate" })}
                                        popperModifiers={
                                            isMobile()
                                                ? undefined
                                                : [
                                                    {
                                                        name: "offset",
                                                        options: {
                                                            offset: [5, 10],
                                                        },
                                                    },
                                                    {
                                                        name: "preventOverflow",
                                                        options: {
                                                            rootBoundary: "viewport",
                                                            tether: false,
                                                            altAxis: true,
                                                        },
                                                    },
                                                ]
                                        }
                                    />
                                </div>
                                <div className="">
                                    <div>To</div>
                                    <DatePicker
                                        minDate={new Date(fromDate)}
                                        selected={new Date(toDate)}
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(date) => handleCustomDate({ date: date, type: "toDate" })}
                                        popperModifiers={
                                            isMobile()
                                                ? undefined
                                                : [
                                                    {
                                                        name: "offset",
                                                        options: {
                                                            offset: [5, 10],
                                                        },
                                                    },
                                                    {
                                                        name: "preventOverflow",
                                                        options: {
                                                            rootBoundary: "viewport",
                                                            tether: false,
                                                            altAxis: true,
                                                        },
                                                    },
                                                ]
                                        }
                                    />
                                </div>
                                <button className={`btn ${classes["apply-filter-btn"]}`} onClick={() => submitHandler()}>Filter</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${isMobile() ? classes['mycontainer-sm'] : classes['mycontainer']}`}>
                {data && data.length > 0 ? <ReactApexChart
                    options={options}
                    height={data.length > 2 ? (data.length > 7 ? data.length * 30 : 325) : 200}
                    width={800}
                    series={series}
                    type="bar"
                /> : <div style={{ padding: '10%' }}>
                    <center><h5>No Results Found</h5></center>
                </div>}
            </div>
        </div>
    )
}

export default Irdashboard